import React from 'react';
import cx from 'classnames';
import { CaptionElementProps } from 'react-day-picker';
import { makeStyles, Theme } from '@material-ui/core/styles';

import { Typography, units } from '@ha/dsl';
import { DateRangePickerProps } from 'ha/components/next/DatePicker/types';

const useStyles = makeStyles((theme: Theme) => ({
  captionContainer: {
    padding: units.trbl(2, 2, 1, 2),
  },
  captionTitle: {
    color: theme.palette.grey[700],
    fontWeight: 'normal',
    textAlign: 'center',
    fontSize: units.rem(1.25),
    marginBottom: units.rem(0.5),
  },
}));

interface OwnProps {
  children?: DateRangePickerProps['CaptionSubtitle'];
}

type Props = OwnProps & CaptionElementProps;

const { H3 } = Typography;

const Caption: React.FC<Props> = props => {
  const { children, classNames, date, localeUtils, locale } = props;
  const { captionContainer, captionTitle } = useStyles();

  return (
    <div
      className={captionContainer}
      data-test-locator="DatePicker/Calendar/Caption"
    >
      <H3 className={cx(captionTitle, classNames?.caption)}>
        {localeUtils.formatMonthTitle(date, locale)}
      </H3>
      {children && <div>{children(date)}</div>}
    </div>
  );
};

export default Caption;
